document.addEventListener("DOMContentLoaded", () => {
    // Initialize the forms module

    // Inicializa cada .blaze-slider de forma independente (desktop e mobile)
    document.querySelectorAll('.blaze-slider').forEach(function(sliderEl) {
        const instance = new BlazeSlider(sliderEl, {
            all: {
                slidesToShow: 1,
                slidesToScroll: 1,
                loop: true,
                enableAutoplay: true,
                autoplayInterval: 5000,
                slideGap: '0px',
                stopAutoplayOnInteraction: false,
                transitionDuration: 800,
                transitionTimingFunction: "ease-in-out"
            }
        });

        const counterBack = sliderEl.querySelector('.counter-back');
        const counterNext = sliderEl.querySelector('.counter-next');
        const progressBar = sliderEl.querySelector('.progress-bar');

        function updateCounters(firstSlideIndex) {
            const total = sliderEl.querySelectorAll('.blaze-slide').length;
            const current = firstSlideIndex + 1;
            const next = current < total ? current + 1 : 1;
            if (counterBack) counterBack.textContent = current < 10 ? `0${current}` : current;
            if (counterNext) counterNext.textContent = next   < 10 ? `0${next}`    : next;
        }

        function startProgress() {
            if (!progressBar) return;
            progressBar.style.transition = 'width 5s linear';
            progressBar.style.width = '100%';
        }

        function resetProgress() {
            if (!progressBar) return;
            progressBar.style.transition = 'none';
            progressBar.style.width = '0%';
            setTimeout(startProgress, 10);
        }

        updateCounters(0);
        startProgress();

        instance.onSlide((pageIndex, firstSlideIndex) => {
            updateCounters(firstSlideIndex);
            resetProgress();
        });
    });

    // input type date
    toggleInputPlaceholders();

    function toggleInputPlaceholders() {
        let inputs = document.querySelectorAll(".form-control[type='date'], .form-control[type='time']");
        
        if (!inputs) return;
    
        function checkInputValue() {
            inputs.forEach(input => {
                if (input.value && input.value.trim() !== "") {
                    input.setAttribute("data-filled", "true");
                } else {
                    input.setAttribute("data-filled", "false");
                }
            })
        }
    
        inputs.forEach(input => {
            input.addEventListener("input", checkInputValue);
        })
        
        checkInputValue();
    }  
    
    
    const phoneInput = document.querySelector("#event-whatsapp");
    if (phoneInput) {
        phoneInput.addEventListener("input", function (e) {
            let value = e.target.value.replace(/\D/g, ""); // Remove tudo que não for número

            if (value.length > 11) {
                value = value.slice(0, 11); // Limita a 11 dígitos
            }

            // Formata o número de telefone corretamente
            if (value.length > 2) {
                value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
            }
            if (value.length > 10) {
                value = `${value.slice(0, 10)}-${value.slice(10)}`;
            }

            e.target.value = value; // Atualiza o valor do input com a máscara
        });
    }

    // =============================
    // Máscara CPF / CNPJ (inclusive CNPJ alfanumérico)
    // =============================
    const cpfCnpjInput = document.getElementById("event-cpf");
    if (cpfCnpjInput) {
        cpfCnpjInput.addEventListener("input", function () {
            let raw = cpfCnpjInput.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            const hasLetter = /[A-Z]/.test(raw);
            const isCNPJ   = hasLetter || raw.length > 11;

            if (isCNPJ) {
                raw = raw.slice(0, 14);
                // XX.XXX.XXX/XXXX-DD
                if (raw.length > 12) {
                    cpfCnpjInput.value = raw.replace(/^(.{2})(.{3})(.{3})(.{4})(.{0,2}).*/, '$1.$2.$3/$4-$5');
                } else if (raw.length > 8) {
                    cpfCnpjInput.value = raw.replace(/^(.{2})(.{3})(.{3})(.+)/, '$1.$2.$3/$4');
                } else if (raw.length > 5) {
                    cpfCnpjInput.value = raw.replace(/^(.{2})(.{3})(.+)/, '$1.$2.$3');
                } else if (raw.length > 2) {
                    cpfCnpjInput.value = raw.replace(/^(.{2})(.+)/, '$1.$2');
                } else {
                    cpfCnpjInput.value = raw;
                }
            } else {
                // CPF numérico: 000.000.000-00
                raw = raw.replace(/\D/g, '').slice(0, 11);
                if (raw.length > 9) {
                    cpfCnpjInput.value = raw.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
                } else if (raw.length > 6) {
                    cpfCnpjInput.value = raw.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
                } else if (raw.length > 3) {
                    cpfCnpjInput.value = raw.replace(/(\d{3})(\d{1,3})/, '$1.$2');
                } else {
                    cpfCnpjInput.value = raw;
                }
            }
        });
    }
})